import React from 'react';
import { FundingInfo } from '../../app/models/Investment/FundingInfo';
import { Header, Segment, Table } from 'semantic-ui-react';

interface Props {
    interestId: number;
    fundingInfo: FundingInfo;
}

function WireTransferInfo({ interestId, fundingInfo }: Props) {
    return (
        <>
            {fundingInfo && <>
                <Segment basic>
                    Use the following information to complete your wire transfer. Once the sponsor has received
                    your payment and updated your funding status, your pledge will be updated.
                </Segment>

                {(fundingInfo.wireTransferInfo.beneficiaryName || fundingInfo.wireTransferInfo.beneficiaryAddress) &&
                    <Segment basic>
                        <Header as="h3" color='blue'>Beneficiary Information</Header>
                        <Table compact className="no-lines">
                            <Table.Body>
                                {fundingInfo.wireTransferInfo.beneficiaryName &&
                                    <Table.Row>
                                        <Table.Cell width={1}><b>Name:</b></Table.Cell>
                                        <Table.Cell>{fundingInfo.wireTransferInfo.beneficiaryName}</Table.Cell>
                                    </Table.Row>
                                }
                                {fundingInfo.wireTransferInfo.beneficiaryAddress &&
                                    <Table.Row>
                                        <Table.Cell><b>Address:</b></Table.Cell>
                                        <Table.Cell>{fundingInfo.wireTransferInfo.beneficiaryAddress}</Table.Cell>
                                    </Table.Row>
                                }
                            </Table.Body>
                        </Table>
                    </Segment>
                }

                <Segment basic>
                    <Header as="h3" color='blue'>Bank Details</Header>
                    <Table compact className="no-lines">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}><b>Bank Name:</b></Table.Cell>
                                <Table.Cell>{fundingInfo.wireTransferInfo.receivingBank}</Table.Cell>
                            </Table.Row>
                            {fundingInfo.wireTransferInfo.bankAddress !== '' &&
                                <Table.Row>
                                    <Table.Cell><b>Bank Address:</b></Table.Cell>
                                    <Table.Cell>{fundingInfo.wireTransferInfo.bankAddress}</Table.Cell>
                                </Table.Row>
                            }
                            <Table.Row>
                                <Table.Cell><b>Account Type:</b></Table.Cell>
                                <Table.Cell>{fundingInfo.wireTransferInfo.accountTypeDescription}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><b>Routing Number:</b></Table.Cell>
                                <Table.Cell>{fundingInfo.wireTransferInfo.routingNumber}</Table.Cell>
                            </Table.Row>
                            <Table.Row>
                                <Table.Cell><b>Account Number:</b></Table.Cell>
                                <Table.Cell>{fundingInfo.wireTransferInfo.accountNumber}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Segment>

                <Segment basic>
                    <Header as="h3" color='blue'>Transaction Details</Header>
                    <Table compact className="no-lines">
                        <Table.Body>
                            <Table.Row>
                                <Table.Cell width={4}><b>Transaction ID:</b></Table.Cell>
                                <Table.Cell>Invoice {interestId}</Table.Cell>
                            </Table.Row>
                        </Table.Body>
                    </Table>
                </Segment>


                <Segment basic>
                    <Header as="h3" color='blue'>Next Steps</Header>
                    <ol>
                        <li>Complete the wire transfer using the details above.</li>
                        <li>
                            Once the transfer is complete, click "I Have Sent the Wire" below to notify us.
                        </li>
                    </ol>
                    <p>
                        Need help?{' '}
                        <a href={`mailto:${process.env.REACT_APP_SUPPORT_EMAIL as string}`}>
                            Contact Support.
                        </a>
                    </p>
                </Segment>
            </>}
        </>
    );
}

export default WireTransferInfo;
